import styled from "styled-components";

import { ReactComponent as ArrowLeft } from "assets/images/ico_arrow_left_s.svg";
import { ReactComponent as ArrowRight } from "assets/images/ico_arrow_right_s.svg";

const CalendarButtonWrapper = styled.div`
  align-items: center;
  margin-left: 8px;
  border-collapse: collapse;
  display: flex;

  .left {
    border-radius: 4px 0 0 4px;
  }

  .right {
    border-radius: 0 4px 4px 0;
    border-left: 0;
  }

  @media (max-width: 1200px) {
    margin-left: 4px;
  }
`;

const CalendarButton = styled.div`
  width: 24px;
  height: 24px;
  background: #ffffff;

  text-align: center;
  cursor: pointer;
  border: 1px solid #e7e9ef;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1200px) {
    width: 28px; // 터치 영역 증가
    height: 28px;
  }

  &:hover {
    background: #f2f4f7;
  }

  &:active {
    background: #e7e9ef;
  }

  svg {
    width: 16px;
    height: 16px;

    @media (max-width: 1200px) {
      width: 18px;
      height: 18px;
    }
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: #F9FAFC;
    opacity: 0.5;
    cursor: not-allowed;

    @media (max-width: 1200px) {
      opacity: 0.3; // 모바일에서 비활성화 상태를 더 명확하게
    }
`}
`;

export const CalendarButtons = ({
  handlePrevDate = () => {},
  handleNextDate = () => {},
  idx = 1,
  total = 1,
}) => (
  <CalendarButtonWrapper>
    <CalendarButton
      className="left"
      disabled={idx === 0}
      onClick={() => idx !== 0 && handlePrevDate()}
    >
      <ArrowLeft />
    </CalendarButton>
    <CalendarButton
      className="right"
      disabled={idx === total - 1}
      onClick={() => idx !== total - 1 && handleNextDate()}
    >
      <ArrowRight />
    </CalendarButton>
  </CalendarButtonWrapper>
);
